module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-72.a1ae10f9.jpg";